import { format, parseISO } from "date-fns";

export function fmtTime(iso) {
  if (!iso) return "—";
  try { return format(parseISO(iso), "HH:mm"); } catch { return "—"; }
}
export function fmtDate(d, pattern = "EEE, d MMM") {
  if (!d) return "";
  try {
    const date = typeof d === "string" ? parseISO(d) : d;
    return format(date, pattern);
  } catch { return ""; }
}
export function fmtFullDate(d) {
  return fmtDate(d, "EEEE, d MMMM yyyy");
}
export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}
export function monthOf(d = new Date()) {
  return d.toISOString().slice(0, 7);
}
export function daysInMonth(yyyymm) {
  const [y, m] = yyyymm.split("-").map(Number);
  return new Date(y, m, 0).getDate();
}
export function dayOfWeek(yyyymmdd) {
  return parseISO(yyyymmdd).getDay(); // 0=Sun
}
